import React from 'react';
import './Contact.css'
import { BsPhone } from 'react-icons/bs';
import { HiOutlineMail } from 'react-icons/hi';
import { GoLocation } from 'react-icons/go';


const Contact = () => {
    return (
        <>

        <section className="contact">
            <div class="d-flex justify-content-center ">
                <div className="mt-2 mb-5">
                    <h3 class="d-flex justify-content-center contactTitle " >Get in Touch</h3>
                    
                </div>
            </div>

            <div className="contactInfo container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="">
                            <div className="mt-3 d-flex">
                                <div className="mr-3">
                                    <BsPhone className="icons mb-3" />
                                </div>
                                <div>
                                    <h5>Call Us On</h5>
                                    <p>+88018 6084 3454</p>
                                </div>
                            </div>
                            <div className="d-flex mt-3">
                                <div className="mr-3">
                                    <HiOutlineMail className="icons mb-3" />
                                </div>
                                <div>
                                    <h4>Email Us At</h4>
                                    <p>sajjadDev@gmail.com</p>
                                </div>
                            </div>
                            <div className="d-flex">
                                <div className="mr-3">
                                    <GoLocation className="icons mb-3" />
                                </div>
                                <div>
                                    <h4>Visit Office</h4>
                                    <p>Dhanmondi, Dhaka 1209</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row mt-3">
                            <div className="col-md-6 mb-3">
                                <input className="nameOrEmail " type="text" placeholder="Your Name*" />
                            </div>
                            <div className="col-md-6">
                                <input className="nameOrEmail" type="text" placeholder="Your Email*" />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-12">
                                <input className="subject" placeholder="Your Subject.." type="text" />
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-md-12">
                                <input type="text" className="message" placeholder="Your Message...." />
                            </div>
                        </div>
                        <div className="mt-3 d-flex justify-content-end">
                            <button class="btn btn-outline-danger">SEND MESSAGE</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    );
};

export default Contact;